import {ACTIONS} from '../../actions/reference.actions';

const initialState = {
  fetchInProgress: false,
  fetchError: '',
  countries: [],
  countriesLoaded: false
}

export default function referenceReducer(state = initialState, action) {

  switch(action.type) {
    case ACTIONS.CountriesLoadInProgress: 
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        countries: [],
        countriesLoaded: false
      };

    case ACTIONS.CountriesLoadCompleted:
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        countries: action.payload,
        countriesLoaded: true
      }
    
    case ACTIONS.CountriesLoadFailed: 
      return {
        ...state,
        fetchInProgress: false,
        fetchError: action.payload,
        countries: [],
        countriesLoaded: false
      }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reference/index.js